
// profileService.ts
// Service for managing and listing supported profiles

export const supportedProfiles: ProfileOption[] = [
    { key: 'support_agent', label: 'Customer Support' },
    { key: 'soc_agent', label: 'SOC' },
    { key: 'noc_agent', label: 'NOC' },
    { key: 'default', label: 'Generic' },
];

export interface ProfileOption {
    key: string;
    label: string;
}

export function getProfileLabel(key: string): string {
    const found = supportedProfiles.find((p) => p.key === key);
    return found ? found.label : key;
}
// Sets the selected profile key in localStorage
export function setStoredProfile(profile: string) {
    if (typeof window !== 'undefined') {
        localStorage.setItem('selectedProfile', profile);
    }
}
// Returns the stored profile key from localStorage if valid, else returns 'default'
export function getStoredProfile(): string {
    if (typeof window !== 'undefined') {
        const stored = localStorage.getItem('selectedProfile') as string | null;
        if (stored && supportedProfiles.some((p) => p.key === stored)) {
            return stored;
        }
    }
    return 'default';
}
